import { render, staticRenderFns } from "./ItemArrayManager.vue?vue&type=template&id=74662e06&scoped=true"
import script from "./ItemArrayManager.vue?vue&type=script&lang=ts"
export * from "./ItemArrayManager.vue?vue&type=script&lang=ts"
import style0 from "./ItemArrayManager.vue?vue&type=style&index=0&id=74662e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74662e06",
  null
  
)

export default component.exports